const AdUnavailabilityService = function AdUnavailabilityService() {};

AdUnavailabilityService.prototype.isAvailable = function isAvailableFn(
  moveIn,
  moveOut,
  unavailabilities
) {
  if (moveIn === '' || moveOut === '') {
    return false;
  }

  const moveInDate = this.getDateWithResetTime(moveIn);
  const moveOutDate = this.getDateWithResetTime(moveOut);

  if (moveInDate >= moveOutDate) {
    return false;
  }

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < unavailabilities.length; i++) {
    const current = unavailabilities[i];
    const fromDate = this.getDateWithResetTime(current.from);
    const toDate = this.getDateWithResetTime(current.to);
    const isOverlapping = toDate >= moveInDate && fromDate <= moveOutDate;

    if (isOverlapping) {
      return false;
    }
  }

  return true;
};

AdUnavailabilityService.prototype.getDateWithResetTime =
  function getDateWithResetTimeFn(date) {
    const resultDate = new Date(date);
    resultDate.setHours(0, 0, 0);

    return resultDate;
  };

export default new AdUnavailabilityService();
